<template>
  <div>
    <!-- 顶部信息 -->
    <div class="myTop">
      <el-breadcrumb style="line-height: 60px;margin-left: 30px;" separator="/">
        <el-breadcrumb-item :to="{ path: '/equipmentManager/equipmentTypeManager' }">设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>信息维护</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 内容 -->
    <div class="roleBox">
      <!-- 导航菜单 -->
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="1">检修专业</el-menu-item>
        <el-menu-item index="2">所属区域</el-menu-item>
        <el-menu-item index="3">维修类别</el-menu-item>
        <el-menu-item index="4">作业票类型</el-menu-item>
      </el-menu>

      <!-- 表格内容1 -->
      <el-table v-if="activeIndex==1" :data="tableData" stripe style="width: 100%">
        <el-table-column prop="name" label="名称" width="280"></el-table-column>
        <el-table-column prop="user" label="用户">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-tag
                  type="info"
                  size="medium"
                  v-for="(item,index) in scope.row.user"
                  :key="index">{{item}}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="oper" label="操作" width="180">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" @click="handDataChange(scope.row.id,scope.row)">编辑</el-link>｜
                <el-link type="primary" @click="handleTaboneDel(scope.row.id)">删除</el-link>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <!-- 表格内容2 -->
      <el-table v-if="activeIndex==2" :data="areaData" stripe style="width: 100%">
        <el-table-column prop="name" label="名称" width="280"></el-table-column>
        <el-table-column prop="user" label="用户">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-tag
                  type="info"
                  size="medium"
                  v-for="(item,index) in scope.row.user"
                  :key="index">{{item}}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="oper" label="操作" width="380">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" @click="handAreaChange(scope.row.id,scope.row)">编辑</el-link>｜
                <el-link type="primary" @click="handleTabtwoDel(scope.row.id)">删除</el-link>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <!-- 表格内容3 -->
      <el-table v-if="activeIndex==3" :data="repairData" stripe style="width: 100%">
        <el-table-column prop="name" label="名称" width="680"></el-table-column>
        <el-table-column prop="oper" label="操作" width="380">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" @click="handserChange(scope.row.id,scope.row)">编辑</el-link>｜
                <el-link type="primary" @click="handleTabthreeDel(scope.row.id)">删除</el-link>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <!-- 表格内容4 -->
      <el-table v-if="activeIndex==4" :data="workTicket" stripe style="width: 100%">
        <el-table-column prop="name" label="名称" width="680"></el-table-column>
        <el-table-column prop="oper" label="操作" width="380">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <div slot="reference" class="name-wrapper">
                <el-link type="primary" @click="handticChange(scope.row.id,scope.row)">编辑</el-link>｜
                <el-link type="primary" @click="handleTabfourDel(scope.row.id)">删除</el-link>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <div style="background-color: #efefef; 
		padding: 18px !important;">
        <el-button class="setAdd" @click="handleAddInfo">添加</el-button>
      </div>

      <el-dialog :title="mesInfo" :visible.sync="dialogVisible" width="30%">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="关联用户">
            <el-select v-model="conPeos" multiple placeholder="关联用户">
              <el-option
                v-for="(item,index) in peosoptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form');dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog :title="mesInfo" :visible.sync="dialogVisible2" width="30%">
        <el-form ref="form2" :model="form2" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="form2.name"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form2');dialogVisible2 = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible2: false,
      form: {
        name: "",
        user: ""
      },
      form2: {
        name: ""
      },
      mesInfo: "新增",
      conPeos: [],
      peosoptions: [],
      ifadd: true,
      tableoneID: "",
      tabletwoID: "",
      tablethreeID: "",
      dialogVisible: false,
      activeIndex: "1",
      tableData: [
        {
          name: "",
          userVos: []
        }
      ],
      areaData: [
        {
          name: "",
          user: []
        }
      ],
      repairData: [
        {
          name: ""
        }
      ],
      workTicket: [
        {
          name: ""
        }
      ]
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    //添加
    handleAddInfo() {
      this.ifadd = true;
      if (this.activeIndex === "1" || this.activeIndex === "2") {
        this.dialogVisible = true;
      } else {
        this.dialogVisible2 = true;
      }
      this.form = {
        name: "",
        user: []
      };
    },
    //提交信息
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ifadd && this.activeIndex === "1") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let user = JSON.stringify(this.conPeos);
            let formdata = new FormData();
            formdata.append("name", name);
            formdata.append("accountIds", user);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").addProInfo
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getTableData();
                this.conPeos = [];
              });
          } else if (!this.ifadd && this.activeIndex === "1") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let user = JSON.stringify(this.conPeos);
            let formdata = new FormData();
            formdata.append("name", name);
            formdata.append("accountIds", user);
            formdata.append("id", this.tableoneID);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeProInfo
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getTableData();
                this.conPeos = [];
              });
          } else if (this.ifadd && this.activeIndex === "2") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let user = JSON.stringify(this.conPeos);
            let formdata = new FormData();
            formdata.append("name", name);
            formdata.append("accountIds", user);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").addAreaInfo
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getareaDate();
                this.conPeos = [];
              });
          } else if (!this.ifadd && this.activeIndex === "2") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let user = JSON.stringify(this.conPeos);
            let formdata = new FormData();
            formdata.append("name", name);
            formdata.append("accountIds", user);
            formdata.append("id", this.tabletwoID);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeAreaInfo
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getareaDate();
                this.conPeos = [];
              });
          } else if (this.ifadd && this.activeIndex === "3") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let formdata = new FormData();
            formdata.append("name", name);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").addserviceType
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getrepairData();
              });
          } else if (!this.ifadd && this.activeIndex === "3") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let formdata = new FormData();
            formdata.append("name", name);
            formdata.append("id", this.tablethreeID);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeserviceType
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getrepairData();
              });
          } else if (this.ifadd && this.activeIndex === "4") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let formdata = new FormData();
            formdata.append("name", name);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").addticketType
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getticketType();
              });
          } else if (!this.ifadd && this.activeIndex === "4") {
            let name = this.$refs[formName].$options.propsData.model.name;
            let formdata = new FormData();
            formdata.append("name", name);
            formdata.append("id", this.tablefourID);
            this.componentsMoudel.httpRequest
              .getRequestHander(
                this.componentsMoudel.getData("urls").changeticketType
              )
              .openLoad()
              .startPost(formdata)
              .then(res => {
                this.getticketType();
              });
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    //获取所有用户信息
    getAllUser() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
        .openLoad()
        .startGet()
        .then(res => {
          res.body.data.forEach((item, index) => {
            this.peosoptions[index] = {};
            this.peosoptions[index].name = item.nickname;
            this.peosoptions[index].id = item.id;
          });
        });
    },
    //获取检修表格信息
    getTableData() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getProInfo)
        .openLoad()
        .startGet()
        .then(res => {
          this.tableData = res.body.data;
          res.body.data.forEach((item, index) => {
            this.tableData[index].user = [];
            item.userVos.forEach((items, ind) => {
              this.tableData[index].user.push(items.nickname);
            });
          });
        });
    },
    //获取所属区域表信息
    getareaDate() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getAreaInfo)
        .openLoad()
        .startGet()
        .then(res => {
          this.areaData = res.body.data;
          res.body.data.forEach((item, index) => {
            this.areaData[index].user = [];
            item.userVos.forEach((items, ind) => {
              this.areaData[index].user.push(items.nickname);
            });
          });
        });
    },
    //获取维修类别
    getrepairData() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getServiceType)
        .openLoad()
        .startGet()
        .then(res => {
          this.repairData = res.body.data;
        });
    },
    //获取作业票类型
    getticketType() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getticketType)
        .openLoad()
        .startGet()
        .then(res => {
          // console.log(res);
          this.workTicket = res.body.data;
        });
    },
    //修改检修表格信息
    handDataChange(id, row) {
      this.mesInfo = "修改";
      this.dialogVisible = true;
      this.ifadd = false;
      this.tableoneID = id;
      this.form.name = row.name;
      this.form.user = row.user;
      this.conPeos = row.user;
      // console.log(this.conPeos);
    },
    //修改区域表格信息
    handAreaChange(id, row) {
      this.mesInfo = "修改";
      this.dialogVisible = true;
      this.ifadd = false;
      this.tabletwoID = id;
      this.form.name = row.name;
      this.form.user = row.user;
    },
    //修改区域表格信息
    handserChange(id, row) {
      this.mesInfo = "修改";
      this.dialogVisible2 = true;
      this.ifadd = false;
      this.tablethreeID = id;
      this.form2.name = row.name;
    },
    //修改作业票类型
    handticChange(id, row) {
      this.mesInfo = "修改";
      this.dialogVisible2 = true;
      this.ifadd = false;
      this.tablefourID = id;
      this.form2.name = row.name;
    },
    // 删除检修表格信息
    handleTaboneDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").delProInfo + id)
        .openLoad()
        .startDel()
        .then(res => {
          if (res.result == "success") {
            this.getTableData();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    },
    //删除区域信息
    handleTabtwoDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delAreaInfo + id
        )
        .openLoad()
        .startDel()
        .then(res => {
          if (res.result == "success") {
            this.getareaDate();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    },
    //删除维修类别
    handleTabthreeDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delserviceType + id
        )
        .openLoad()
        .startDel()
        .then(res => {
          if (res.result == "success") {
            this.getrepairData();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    },
    //删除作业票类型
    handleTabfourDel(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander(
          this.componentsMoudel.getData("urls").delticketType + id
        )
        .openLoad()
        .startDel()
        .then(res => {
          if (res.result == "success") {
            this.getticketType();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
    }
  },
  created() {
    this.getAllUser();
    this.getTableData();
    this.getareaDate();
    this.getrepairData();
    this.getticketType();
  }
};
</script>

<style scoped="">
.roleBox {
  padding: 8px;
  background-color: #ffffff;
}
.el-menu-demo {
  padding: 10px 0 0 20px;
}
.setAdd {
  width: 86%;
  height: 28px !important;
  display: block;
  border: 1px dashed #e9eef3;
  margin: 0 auto;
  line-height: 8px !important;
}
.myTop {
  background-color: #ffffff;
  width: 89%;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
}
.myBtn {
  position: absolute;
  top: 10px;
  right: 30px;
}
.el-input--suffix {
  width: 200px;
}
</style>
